import HeroProductStack from "./HeroProductStack.jsx";
import s from "./AccessoriesHero.module.css";

export default function AccessoriesHero({ products, isLoading }) {
  const heroProducts = (products || []).slice(0, 3);

  const scrollToCatalog = () => {
    const el = document.getElementById("accessories-catalog");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className={s.hero}>
      <div>
        <span className={s.eyebrow}>Accessories</span>
        <h1 className={s.title}>
          Got it signed?
          <br />
          Now <span className={s.accent}>protect&nbsp;it.</span>
        </h1>
        <p className={s.lede}>
          Frames, top loaders, display cases, and Funko protectors — picked for
          the autographs you collect on Streamily. Built to keep what they
          signed looking exactly the way they signed it.
        </p>
        <div className={s.actions}>
          <button
            type="button"
            className={s.btnPrimary}
            onClick={scrollToCatalog}
          >
            Shop accessories
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M2 7 L12 7 M8 3 L12 7 L8 11" />
            </svg>
          </button>
        </div>
      </div>

      {!isLoading && <HeroProductStack products={heroProducts} />}
    </section>
  );
}
